export const SESSION_EXPIRED_EVENT = "sms:session-expired";

export type SessionExpiredDetail = {
  title: string;
  message: string;
};

export function emitSessionExpired(detail: SessionExpiredDetail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
}
